export function setFormValue (internal: ElementInternals, value) {
  if (typeof internal.setFormValue === 'function')
    internal.setFormValue(value)
}

export function setValidityMissingValue (internal: ElementInternals, value, emptyFieldMessage = "Field cannot be empty") {
  if (typeof internal.setValidity === 'function')
    internal.setValidity({ valueMissing: !value || value === '' }, emptyFieldMessage)
}